<template>
  <v-container class="dashboard-boxes pa-4 rounded-xl">
    <v-row dense>
      <!-- Total Students -->
      <v-col cols="12" sm="4">
       <router-link to="/class-info/" class="router-link-wrapper">
          <v-hover v-slot:default="{ isHovering, props }">
          <v-sheet
            v-bind="props"
            class="dashboard-box rounded-xl pa-4 d-flex align-center transition-ease-in-out w-100"
            :elevation="isHovering ? 10 : 4"
          >
            <v-icon :color="isHovering ? 'primary' : 'grey'" size="40">mdi-account-group</v-icon>
            <div class="ms-4">
              <div class="text-h6 font-weight-bold">{{ totalStudents }}</div>
              <div class="text-subtitle-2">Total Students</div>
            </div>
          </v-sheet>
        </v-hover>
        </router-link>
      </v-col>

      <!-- Total Employees -->
      <v-col cols="12" sm="4">
         <router-link to="/employeeDetail/" class="router-link-wrapper">
        <v-hover v-slot:default="{ isHovering, props }">
          <v-sheet
            v-bind="props"
            class="dashboard-box rounded-xl pa-4 d-flex align-center transition-ease-in-out w-100"
            :elevation="isHovering ? 10 : 4"
          >
            <v-icon :color="isHovering ? 'green' : 'grey'" size="40">mdi-badge-account</v-icon>
            <div class="ms-4">
              <div class="text-h6 font-weight-bold">{{ totalEmployees }}</div>
              <div class="text-subtitle-2">Total Employees</div>
            </div>
          </v-sheet>
        </v-hover>
        </router-link>
      </v-col>  

      <!-- Total Classes -->
      <v-col cols="12" sm="4" class="position-relative">
          <router-link to="/class-info/" class="router-link-wrapper">
        <v-hover v-slot:default="{ isHovering, props }">
          <v-sheet
            v-bind="props"
            class="dashboard-box rounded-xl pa-4 d-flex align-center transition-ease-in-out w-100"
            :elevation="isHovering ? 10 : 4"
          >
            <v-icon :color="isHovering ? 'deep-purple' : 'grey'" size="40">mdi-google-classroom</v-icon>
            <div class="ms-4">
              <div class="text-h6 font-weight-bold">{{ totalVerifiedClasses }}</div>
              <div class="text-subtitle-2">Total Classes</div>
            </div>
          </v-sheet>
        </v-hover>
        </router-link>

        <!-- <img
          src="@/assets/images/welcome-2.gif"
          alt="welcome"
          class="welcome-2 d-none d-sm-block position-absolute"
          style="bottom: -10px; right: -10px; width: 60px; height: 60px;"
        /> -->
      </v-col>
    </v-row>
  </v-container>
  <v-container class="welcome-container mt-4">
    <div class="row">
      <div class="card bg-white rounded-3 shadow-sm mb-4 p-4">
        <h4 class="fw-semibold mb-3 text-primary">
          <i class="material-symbols-outlined align-middle me-2">rocket_launch</i>
          Your Quick Start Guide
        </h4>
        <ol class="get-started-steps ps-3">
          <li>
            <i class="material-symbols-outlined text-primary me-2">school</i>
            <span>
              <b>Step 1:</b> Fill in your 
              <a class="step-link" href="/school-detail"><b>School Details</b></a> (name, address, logo, etc.).
            </span>
          </li>
          <li>
            <i class="material-symbols-outlined text-primary me-2">class</i>
            <span>
              <b>Step 2:</b> Create 
              <a class="step-link" href="/class-info"><b>Classes</b></a>.
            </span>
          </li>
          <li>
            <i class="material-symbols-outlined text-primary me-2">group</i>
            <span>
              <b>Step 3:</b> Add <a class="step-link" href="/user-list"><b>Administrators</b></a> to manage your system.
            </span>
          </li>
          <li>
            <i class="material-symbols-outlined text-primary me-2">upload_file</i>
            <span>
              <b>Step 4:</b> <b>Download</b> the provided format and <b><a class="step-link" href="/uploadFile/student">Upload Student</a> & <a class="step-link" href="/uploadFile/employee">Employee Data</a></b> in bulk or add them manually.
            </span>
          </li>
          <li>
            <i class="material-symbols-outlined text-primary me-2">image</i>
            <span>
              <b>Step 5:</b> <a class="step-link" href="/uploadFile"><b>Upload Profile Pictures</b></a> for students and employees.
            </span>
          </li>
          <li>
            <i class="material-symbols-outlined text-primary me-2">badge</i>
            <span>
              <b>Step 6:</b> <a class="step-link" href="/generate-id-card"><b>Validate</b></a> your data, select your preferred <b>ID Card Template</b>, and <b>place your order</b>.
            </span>
          </li>
        </ol>
      </div>
    </div>
    <!-- <img
      src="@/assets/images/welcome-2.gif"
      class="welcome-2 d-none d-sm-block"
      alt="welcome"
    /> -->
  </v-container>
</template>


<script setup>
import { ref, computed, onMounted } from "vue";
import { totalCountForDashboard } from "@/services/apiServices";
// import { useProfileStore } from "@/Store/profileStore";
// import { useTheme } from "@/composables/useThemes";
// const { isDarkTheme } = useTheme();
// Stores
// const profileStore = useProfileStore();
// const profile = computed(() => profileStore.ProfileData);

// Totals
const totalStudents = ref(0);
const totalEmployees = ref(0);
const totalVerifiedClasses = ref(0);

// Fetch everything on mount
onMounted(async () => {
  // await profileStore.fetchProfileData();

  try {
    const data = await totalCountForDashboard();
    // console.log("Total counts:", data);
    totalStudents.value = data.student_count;
    totalEmployees.value = data.employee_count;
    totalVerifiedClasses.value = data.class_count;
  } catch (err) {
    console.error("Error fetching totals:", err);
  }
});
</script>

<style>
.welcome-2 {
  animation: floatY 2s ease-in-out infinite;
}
.router-link-wrapper {
  text-decoration: none !important ;
  display: block;
}

@keyframes floatY {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}


</style>